import constants from '@/utils/constants'
const timetableRouter = [{
  path: '/timetable',
  name: 'timetable',
  meta: {
    title: '更新学堂-课程表'
  },
  redirect: to => {
    let path = ''
    if (to.query.goodsType) {
      if (to.query.goodsType == constants.goodsType.offlineClass) {
        path = '/offline-class-list'
      } else {
        path = '/train-list'
      }
    } else {
      path = '/home'
    }
    return { path: path, query: to.query }
  },
},
{
  path: "/offline-class-list",
  name: "offline-class-list",
  component: _ => import("@/pages/timetable/offline-class-list.vue"),
  meta: {
    title: '实战坊'
  }
},
{
  path: "/train-list",
  name: "train-list",
  component: _ => import("@/pages/timetable/train-list.vue"),
  meta: {
    title: '训练营'
  }
},
{
  path: "/timetable/schedule",
  name: "timetable-schedule",
  component: _ => import("@/pages/timetable/schedule.vue"),
  meta: {
    title: '排期'
  }
},
{
  path: "/live-broadcast-list",
  name: 'live-broadcast-list',
  component: _ => import("@/pages/timetable/live-broadcast-list.vue"),
  meta: {
    title: '直播'
  }
},
{
  path: "/online-course-list",
  name: 'online-course-list',
  component: _ => import("@/pages/timetable/online-course-list.vue"),
  meta: {
    title: '线上课'
  }
}
]
export default timetableRouter